import { useEffect, useState } from "react";
import "./style.css";

export const CheckBoxCard = ({
  display_name,
  name,
  handleCheckProvider,
  children,
  defaultValue = false,
}) => {
  
  return (
    <div className={`upload-card ${defaultValue ? "upload-card--checked" : ""}`}>
      <div className="upload-card__checkbox">
        <input
          type="checkbox"
          checked={defaultValue}
          onChange={() => handleCheckProvider(name)}
        />
      </div>

      <div className="upload-card__content">
        {
          children ? children : <h3 className="upload-card__title">{display_name}</h3>
        }
      </div>
    </div>
  );
};
